import React from 'react';
import PropTypes from 'prop-types';

const TopSeller = ({ sellers, tablaEstilo }) => {
  const sellerArray = sellers?.topVentas || sellers;
  return (
    <div className="table-responsive mb-3">
      <table
        className="table table-sm table-hover mb-0"
        style={{ background: tablaEstilo?.fondo, borderRadius: 6, overflow: 'hidden' }}
      >
        <thead className="thead-light">
          <tr style={{ background: tablaEstilo?.header }}>
            <th>Id</th>
            <th>Nombre</th>
            <th className="text-right">Unidades</th>
          </tr>
        </thead>
        <tbody>
          {Array.isArray(sellerArray) && sellerArray.length > 0 ? (
            sellerArray.map((s, idx) => (
              <tr key={s.idSeller + idx}>
                <td>{s.idSeller || '-'}</td>
                <td>{s.nombreSeller || s.razonSocial || s.seller || '-'}</td>
                <td className="text-right">{s.unidadesVendidas || '-'}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={3} className="text-center text-muted py-3">Sin datos</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

TopSeller.propTypes = {
  /**
   * sellers: puede ser:
   * 1) Array de objetos con estructura:
   *    { idSeller: number, nombreSeller: string, unidadesVendidas: number }
   * 2) Objeto con propiedad 'topVentas' que contiene el array
   */
  sellers: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.shape({
        idSeller: PropTypes.number,
        nombreSeller: PropTypes.string,
        razonSocial: PropTypes.string,
        seller: PropTypes.string,
        unidadesVendidas: PropTypes.number,
      })
    ),
    PropTypes.shape({
      topVentas: PropTypes.arrayOf(
        PropTypes.shape({
          idSeller: PropTypes.number,
          nombreSeller: PropTypes.string,
          razonSocial: PropTypes.string,
          seller: PropTypes.string,
          unidadesVendidas: PropTypes.number,
        })
      ),
    }),
  ]),

  /**
   * tablaEstilo: objeto con propiedades CSS para estilizar la tabla
   * fondo: color de fondo de las celdas
   * header: color de fondo del header
   * borde (opcional): estilo del borde
   */
  tablaEstilo: PropTypes.shape({
    fondo: PropTypes.string,
    header: PropTypes.string,
    borde: PropTypes.string,
  }),
};

export default TopSeller;
